import React from 'react';
import {
  Avatar,
  Chip,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  Tooltip,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { FaTractor, FaHelicopter, FaTrailer, FaCarSide, FaMotorcycle } from 'react-icons/fa';
import { RiTruckFill } from 'react-icons/ri';

interface Props {
  item: {
    hash: string;
    type: string;
    file_name: string;
    note: string;
    created_at: string;
    is_active: boolean;
  };
  onDownload: (hash: string) => void;
}

const SpreadsheetListItem: React.FC<Props> = ({ item, onDownload }) => {
  const getIconByType = (type: string) => {
    switch (type) {
      case '1': return <FaTractor />;
      case '2': return <FaHelicopter />;
      case '3': return <FaTrailer />;
      case '4': return <RiTruckFill />;
      case '6':
        return (
          <img
            width="20"
            height="20"
            src="https://img.icons8.com/material-rounded/96/harvester.png"
            alt="harvester"
          />
        );
      case '7': return <><FaMotorcycle /><FaCarSide/></>
      default:
        return null;
    }
  };

  return (
    <ListItem
      alignItems="flex-start"
      secondaryAction={
        <div className="flex flex-col gap-2">
          <Tooltip title="Baixar">
            <IconButton
              edge="end"
              aria-label="download"
              onClick={() => onDownload(item.hash)}
              sx={{ color: '#00AEEF' }}
            >
              <DownloadIcon />
            </IconButton>
          </Tooltip>
        </div>
      }

    >
      <ListItemAvatar>
        <Avatar>{getIconByType(item.type)}</Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={item.file_name}
        secondary={
          <>
            <Typography variant="body1" color="text.primary" component="span">
              {item.note}
            </Typography>
            <br />
            <Typography variant="body1" color="text.primary" component="span">
              {`Cadastrada no dia ${item.created_at}`}
            </Typography>
            <br />
            <Chip
              label={item.is_active ? 'Planilha ativa' : 'Planilha inativa'}
              color={item.is_active ? 'success' : 'error'}
              sx={{
                color: item.is_active ? 'inherit' : '#fff'  
              }}
              component="span"
            />
          </>
        }
      />
    </ListItem>
  );
};

export default SpreadsheetListItem;